// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CaseFollowUpResultModel } from './caseFollowUpResultModel.js';
import type { CaseModel } from './caseModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description processing result model
*/
export class CaseProcessingResultModel {
    'updatedCase'?: CaseModel | null;
    'newCaseIds': Array<number> | null;
    'previousCaseId'?: number;
    'targetStatusId'?: number;
    'targetSubStatusId'?: number;
    'caseFollowUpResults': Array<CaseFollowUpResultModel> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CaseProcessingResultModel>> = [
        {
            "name":     "updatedCase",
            "baseName": "updatedCase",
            "type":     "CaseModel"
        },
        {
            "name":     "newCaseIds",
            "baseName": "newCaseIds",
            "type":     "Array<number>"
        },
        {
            "name":     "previousCaseId",
            "baseName": "previousCaseId",
            "type":     "number"
        },
        {
            "name":     "targetStatusId",
            "baseName": "targetStatusId",
            "type":     "number"
        },
        {
            "name":     "targetSubStatusId",
            "baseName": "targetSubStatusId",
            "type":     "number"
        },
        {
            "name":     "caseFollowUpResults",
            "baseName": "caseFollowUpResults",
            "type":     "Array<CaseFollowUpResultModel>"
        },
    ];

    static getAttributeTypeMap() {
        return CaseProcessingResultModel.attributeTypeMap;
    }
}
